"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RenderHeaderGroup = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SortButton = _interopRequireDefault(require("./SortButton"));
var _tableContext = require("../../Context/tableContext");
var _RowSelection = _interopRequireDefault(require("./RowSelection"));
var _FilterDropdownHOC = _interopRequireDefault(require("./FilterDropdownHOC"));
var _Tooltip = _interopRequireDefault(require("../../../Tooltip"));
var _ykbStyledComponents = require("../../../ykb-styled-components");
var _templateObject, _templateObject2, _templateObject3;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var RenderHeaderGroup = exports.RenderHeaderGroup = function RenderHeaderGroup(_ref) {
  var _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? [] : _ref$columns,
    prefixCls = _ref.prefixCls;
  var offsetWidth = 0; // TODO = kolon sabitlemesiyle ilgili bişey iptal olucak.
  var filterComponentWidth = 18;
  var FixedColumnsStyles = (0, _react.useRef)(null);
  var HeaderRowRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    //her column verisi değiştiğinde fixed column hesabı yapılacak
    var fixedColumns = [];
    var calculatedValue = 0,
      previousValidIndex = -1;
    if (columns && columns.length > 0) {
      fixedColumns = columns.map(function (q, i) {
        if (!!q.fixed) {
          return [q, HeaderRowRef.current.getRootNode().querySelector(".header-cell-".concat(i))];
        }
      });
    }
    FixedColumnsStyles.current = (0, _ykbStyledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      ", "\n    "])), fixedColumns.map(function (item, index) {
      if (!item) return;
      var _item = (0, _slicedToArray2.default)(item, 1),
        column = _item[0];
      var direction = column.fixed || 'left';
      if (column.fixed) {
        var _column = fixedColumns[previousValidIndex];
        var element = _column && _column[1];
        previousValidIndex = index;
        calculatedValue += (element === null || element === void 0 ? void 0 : element.offsetWidth) || 0;
      }
      return (0, _ykbStyledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n          .table-container\n            .ykb-ui-table-tbody\n            > tr\n            .sticky-cell.left:nth-child(", ") {\n            position: sticky;\n            ", ": ", "px;\n          }\n\n          .table-container\n            .ykb-ui-table-thead\n            > tr\n            .sticky-cell.left:nth-child(", ") {\n            position: sticky;\n            ", ": ", "px;\n          }\n        "])), index + 1, direction, calculatedValue, index + 1, direction, calculatedValue);
    }));
  }, [columns]);
  var Styles = (0, _ykbStyledComponents.createGlobalStyle)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  "])), FixedColumnsStyles.current);
  return /*#__PURE__*/_react.default.createElement("tr", {
    key: "RenderHeader-".concat(0),
    ref: HeaderRowRef
  }, /*#__PURE__*/_react.default.createElement(Styles, null), columns.map(function (column, index) {
    var _column$fixed, _column$fixed2;
    var isFixedColumn = (_column$fixed = column.fixed) !== null && _column$fixed !== void 0 ? _column$fixed : false;
    var fixedKey = (_column$fixed2 = column.fixed) !== null && _column$fixed2 !== void 0 ? _column$fixed2 : 'left';
    var isCanSort = !!column.sorter;
    var hasFilter = column.autoFilter || typeof column.filterDropdown === 'function';
    var filterClass = hasFilter ? "".concat(prefixCls, "-column-has-actions ").concat(prefixCls, "-column-has-filters") : '';
    var width = column.width;
    var title = column.title;
    var tdStyle = {
      // position: 'sticky',
      zIndex: columns.dataIndex === 'rowSelection' ? 9 : isFixedColumn ? 3 : 2,
      // [fixedKey]: isFixedColumn ? offsetWidth : isFixedColumn ? 1 : 'unset',
      top: 0
      // width: hasFilter ? width - filterComponentWidth : width,
    };
    var preparedClassName = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "ykb-ui-table-cell", true), filterClass, true), "header-cell-".concat(index), true), 'sticky-cell', isFixedColumn), fixedKey, isFixedColumn), 'row-selection', column.dataIndex === 'rowSelection'), "table-column-".concat(column.dataIndex), true));
    if (column.dataIndex == 'rowSelection') {
      var rowSelection = _tableContext.eventHub.getState('rowSelection');
      var selectionProps = rowSelection && typeof rowSelection.getCheckboxHeaderProps === 'function' ? rowSelection.getCheckboxHeaderProps({
        isActiveFilter: isActiveFilter
      }) : {};
      return /*#__PURE__*/_react.default.createElement("th", {
        key: "RenderHeader-th-".concat(index),
        className: preparedClassName,
        style: tdStyle
      }, /*#__PURE__*/_react.default.createElement(_RowSelection.default, (0, _extends2.default)({
        checkStrictly: rowSelection.checkStrictly,
        rowKey: "header-selection"
      }, selectionProps)));
    }
    var innerClassname = (0, _classnames.default)({
      'has-filter': hasFilter,
      'header-cell-inner': true
    });
    var HeaderWrapper = !isCanSort || columnDef.showSorterTooltip === false ? _react.Fragment : _Tooltip.default;
    var onHeaderCell = (0, _react.useCallback)(function () {
      if (!hasFilter) return;
      //TODO sorting yazılcak.
      // return header.column.getToggleSortingHandler();
    }, []);
    return /*#__PURE__*/_react.default.createElement("th", {
      key: "RenderHeader-th-".concat(index),
      className: preparedClassName,
      style: _objectSpread({
        whiteSpace: 'nowrap'
      }, tdStyle)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: innerClassname
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: column.size
      }
    }, /*#__PURE__*/_react.default.createElement(HeaderWrapper, null, /*#__PURE__*/_react.default.createElement("span", {
      key: "title",
      className: "".concat(prefixCls, "-header-column"),
      onClick: onHeaderCell
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: isCanSort ? "".concat(prefixCls, "-column-sorters") : undefined
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "".concat(prefixCls, "-column-title")
    }, title), isCanSort && /*#__PURE__*/_react.default.createElement("span", {
      className: "".concat(prefixCls, "-column-sorter")
    }, /*#__PURE__*/_react.default.createElement(_SortButton.default, {
      locale: locale,
      header: header,
      table: table,
      prefixCls: prefixCls
    }))))), /*#__PURE__*/_react.default.createElement(_FilterDropdownHOC.default, {
      column: column,
      prefixCls: prefixCls
      // header={header}
      // table={table}
      // {...props}
      // data={props.flattenData || []}
    }))));
  }));
};
var _default = exports.default = RenderHeaderGroup;